/*
 * @Author: 傅丽宇
 * @Date: 2019-12-06 09:59:19
 * @LastEditTime: 2020-11-18 10:22:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \orange_big_data\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/views/HomePage'
import center from '@/views/center'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js